export const tesEmployeeDetailsRoutes = [
  {
    path: ':reference_number',
    name: 'tes-employees-details',
    component: () =>
      import(/* webpackChunkName: "Tes-Employees-details" */ './TesEmployeeDetails.vue')
  }
];
